import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class PucaUploadDocumentService {
	constructor(public http: HttpClient) {}

	public uploadDocument(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_PROFILE + "doc/uploadDocument/",
			payload
		);
	}

	public getDocumentList(processAcronym, applicationId): Observable<any> {
		return this.http.get(
			environment.BASE_URL_PROFILE +
				"doc/getFileNames/" +
				processAcronym +
				"/" +
				applicationId
		);
	}

	public saveDocumentDetails(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_PROFILE + "doc/uploadDocument",
			payload
		);
	}

	public getUploadDocumentList() {
		const list = [
			{
				label: "University Admission Letter",
				value: 1,
				type: "PDF",
				Mandatory: true,
				maxSize: 1000,
			},
			{
				label: "Computerized National Identity Card (CNIC)",
				value: 2,
				type: "PDF",
				Mandatory: true,
				maxSize: 1000,
			},
			{
				label: "All pages of Passport",
				value: 3,
				type: "PDF",
				Mandatory: true,
				maxSize: 1000,
			},
			{
				label: "Curriculum Vitae (CV)",
				value: 4,
				type: "PDF",
				Mandatory: true,
				maxSize: 512,
			},
			// {
			// 	label: "Statement of Purpose",
			// 	value: 5,
			// 	type: "PDF",
			// 	Mandatory: true,
			// 	maxSize: 512,
			// },
			// {
			// 	label: "Research Proposal",
			// 	value: 6,
			// 	type: "PDF",
			// 	Mandatory: true,
			// 	maxSize: 1,
			// },
			{
				label: "All Educational Degrees & Transcripts (as filled in the form)",
				value: 7,
				type: "PDF",
				Mandatory: true,
				maxSize: 512,
			},
			{
				label: "Relevant GRE or HAT Score Card",
				value: 8,
				type: "PDF",
				Mandatory: true,
				maxSize: 512,
			},
			{
				label: "University Rank Link Screenshot",
				value: 9,
				type: "PDF",
				Mandatory: true,
				maxSize: 512,
			},
		];

		return list;
	}

	public deleteDocument(payload): Observable<any> {
		return this.http.post(
			environment.BASE_URL_PROFILE + "doc/deleteDocument",
			payload
		);
	}

	public getAttachmentByDocumentId(payload) {
		return this.http.get(
			environment.BASE_URL_PROFILE +
				"doc/downloadFile/" +
				payload.data.fileName +
				"/" +
				payload.data.processAcronym +
				"/" +
				payload.data.applicationId,
			{ responseType: "blob" }
		);
	}
}
